import { useEffect, useCallback } from 'react';

/**
 * @description 移除 URL 查询参数
 */
const removeQueryParameter = (key: string, url = window.location.href): string => {
  const parsedUrl = new URL(url);
  const searchParams = parsedUrl.searchParams;
  searchParams.delete(key);
  return parsedUrl.toString();
};

/**
 * @description 更新 URL 查询参数
 */
const updateQueryParameter = (key: string, value: string, url = window.location.href): string => {
  try {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;
    searchParams.set(key, value);
    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return url; // 返回原始 URL
  }
};

/**
 * @description 更新 URL 参数
 */
const changeURL = (key: string, value?: string, url = window.location.href): string => {
  let modifiedUrl = url;

  if (key && value) {
    modifiedUrl = updateQueryParameter(key, value, url);
  } else if (key) {
    modifiedUrl = removeQueryParameter(key, url);
  }

  window.history.pushState({}, '', modifiedUrl);
  return modifiedUrl; // 返回修改后的 URL
};

/**
 * @description 处理 dragComponentId 的 Hook
 * 包含 URL 更新逻辑和 message 事件监听
 */
const useDragComponentId = () => {
  // 封装 changeURL 逻辑
  const updateURL = useCallback((key: string, value?: string) => {
    changeURL(key, value);
  }, []);

  // 监听 message 事件
  useEffect(() => {
    // 先写个7，因为3d经常会返回7，这里做兼容0203版本的拖拽问题
    ;(window as any).mk6DragComponentId = '7';
    const handleMessage = (event: MessageEvent) => {
      const { origin, data } = event?.data ?? {};
      const { action, params } = data ?? {};

      // 检查消息来源和操作是否正确
      if (origin !== 'uiapi.materialUi' || !action) return;

      // 处理 setDragComponentId
      if (action === 'setDragComponentId' && params?.dragComponentId) {
        const dragComponentId = params.dragComponentId;
        if (dragComponentId) {
          (window as any).dragComponentId = dragComponentId;
          updateURL('dragComponentId', dragComponentId);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [updateURL]);
};

export default useDragComponentId;

